import { render, staticRenderFns } from "./Account_setting.vue?vue&type=template&id=39c4098e&scoped=true&"
import script from "./Account_setting.vue?vue&type=script&lang=js&"
export * from "./Account_setting.vue?vue&type=script&lang=js&"
import style0 from "./Account_setting.vue?vue&type=style&index=0&id=39c4098e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4098e",
  null
  
)

export default component.exports